/**
 * Action Center seen-state API (DEV-1209). Server-side per-user "seen" markers
 * so the Inbox unseen/seen lifecycle survives reloads and is consistent across
 * browsers/devices. The localStorage cache in ActionCenterInbox remains as an
 * instant-paint fallback; the server is authoritative.
 */

import { apiFetch } from "./client";

/** The caller's seen Action Center item keys. */
export async function fetchSeenItemKeys(): Promise<string[]> {
  return apiFetch<string[]>("/api/action-items/seen");
}

/** Mark one or more items seen (idempotent server-side). Fire-and-forget from the UI. */
export async function markItemsSeen(itemKeys: string[]): Promise<void> {
  if (!itemKeys.length) return;
  await apiFetch<void>("/api/action-items/seen", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ itemKeys }),
  });
}
